<template>
  <div class=" ">
    <v-layout>
      <v-flex>
        <section>
          <v-card flat>
            <v-card-text class="pa-0">

              <v-row 
                style="height: 100vh;">
                <v-col 
                  cols="12"
                  md="5"
                  class="pl-9">
                  <v-card class="" flat style="background: #240087; border-radius: 16px;" height="100%">
                    <v-card-text class="pa-10" style="height: 100%;">
                      <div>
                        <div>
                          <div class="mb-12">
                            <v-img
                              src="@/assets/logo/Logo_white.png"
                              contain
                              style="width: 273px; height: 40px;">
                            </v-img>
                          </div>
                          <div>
                            <div class="fs-32 white--text font-weight-bold mb-6">
                              Integrated Distributor App
                            </div>
                            <div class="fs-15 white--text">
                              Layanan Sistem Informasi Distributor Terintegrasi dalam mengelola dan mengembangkan Usaha Anda.
                            </div>
                          </div>
                        </div>
                        <div class="mt-16 pt-16">
                          <v-img
                            src="@/assets/image/img_login.png"
                            contain>
                          </v-img>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12"
                  md="7"
                  style="height: 100%; display: flex; align-items: center; justify-content: center;">
                  <v-card
                    flat
                    style="width: 500px;">
                    <div>
                      <v-card
                        flat
                        color="#FFFFFFB2"
                        class="border-radius">
                        <v-card-text
                          class="pa-0">
                          <div
                            class="mb-6">
                            <div
                              class="fs-30 black_one font-weight-bold black--text mb-12">
                              Masuk
                            </div>
                          </div>
    
                          <ValidationObserver 
                            ref="observer">
                            <v-form class="text-left mb-6">
                              <div class="fs-16 label-input">
                                Email
                              </div>
                              <ValidationProvider 
                                name="Email" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  solo
                                  :color="set_color"
                                  placeholder="Email"
  
                                  vv-uppercase
  
                                  v-model="form.username"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
  
                              <div class="fs-16 label-input">
                                Password
                              </div>
                              <ValidationProvider 
                                name="password" 
                                rules="required|min:5|max:20" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  solo
                                  :color="set_color"
                                  placeholder="Password"
                                  :type="show ? 'text' : 'password'"
                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="show = !show"
                                  :counter="20"
  
                                  vv-uppercase
                                  
                                  v-model="form.password"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>
    
                          <div 
                            class="text-center mb-6">
                            <div v-if="message.error.length > 0"
                              class="text-center my-4">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>
    
                            <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                              <span class="cursor-pointer">Lupa Kata Sandi</span>
                            </div> -->
    
                            <v-btn
                              :disabled="process.form"
                              :loading="process.form"
                              @click="save()"
                              block
                              color="#6948c6"
                              width="170"
                              height="45"
                              elevation="0"
                              style="border-radius: 6px;"
                              class="title font-weight-bold white--text text-capitalize">
                              Masuk
                            </v-btn>
  
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.category_user_menu_arr.length < 1 ? [] : JSON.parse(res.results.data.category_user_menu_arr),
                  menu_default = [
        { 
                      id: 1,
                      title: 'User',
                      icon: "mdi-badge-account-outline",
                      color: "primary",
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          id: 2,
                          title: 'Staff',
                          link: '/user/staff',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 3,
                          title: 'Supplier',
                          link: '/user/supplier',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 4,
                          title: 'Kategori Staff',
                          link: '/user/category',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 10,
                      title: 'Sales',
                      icon: 'mdi-account-tie',
                      color: "pink",
                      link: '/sales',
                      active: false,
                      sub_menu: [
                        {
                          id: 11,
                          title: 'sales',
                          link: '/sales/staff',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 12,
                          title: 'Kode Sales (Area Sales)',
                          link: '/sales/code',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 13,
                          title: 'Target Sales',
                          link: '/sales/target',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 6,
                      title: 'Customer',
                      icon: 'mdi-account-group',
                      color: "success",
                      link: '/customer/data',
                      active: false,
                      sub_menu: [
                      {
                          id: 7,
                          title: 'Customer Saya',
                          link: '/customer/data',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 59,
                          title: 'Pengajuan Customer',
                          link: '/customer/proses',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 60,
                          title: 'Proses Pengajuan',
                          link: '/customer/acc',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 61,
                          title: 'Histori Rejected',
                          link: '/customer/reject',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 8,
                        //   title: 'Toko',
                        //   link: '/customer/toko',
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 8,
                          title: 'Perubahan Plafon',
                          link: '/customer/plafon',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 9,
                          title: 'Perubahan Customer',
                          link: '/customer/perubahan',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 14,
                      title: 'Produk',
                      icon: 'mdi-package-variant',
                      color: "warning",
                      link: '/product',
                      active: false,
                      sub_menu: [
                        {
                          id: 15,
                          title: 'Data Produk',
                          link: '/product/data',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 16,
                          title: 'Varian Produk',
                          link: '/product/varian',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 17,
                          title: 'Kategori Produk',
                          link: '/product/category_product',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 18,
                          title: 'Group Produk',
                          link: '/product/group',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                  {
                    id: 41,
                    title: 'Stok',
                    icon: 'mdi-text-box-check',
                    color: "#00838F",
                    link: '/stok',
                    active: false,
                    sub_menu: [
                      {
                        id: 42,
                        title: 'Stok',
                        link: '/stok/data',
                        icon: 'mdi-text-box-check',
                        color: "#00838F",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 43,
                        title: 'Stok In Order',
                        link: '/stok/in-order',
                        icon: 'mdi-text-box-check',
                        color: "#00838F",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                    {
                      id: 22,
                      title: 'Kelola Visit',
                      icon: 'mdi-map-marker',
                      color: "#00838F",
                      link: '/visit',
                      active: false,
                      sub_menu: [
                        {
                          id: 23,
                          title: 'Laporan Visit',
                          link: '/visit/data',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 78,
                          title: 'Laporan Visit Detail',
                          link: '/visit/laporan',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 24,
                          title: 'Buat Jadwal Visit',
                          link: '/visit/jadwal',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 25,
                      title: 'Presensi',
                      icon: 'mdi-fingerprint',
                      color: "#BF360C",
                      link: '/presensi',
                      active: false,
                      sub_menu: [
                        {
                          id: 26,
                          title: 'Laporan Presensi',
                          link: '/presensi/data',
                          icon: 'mdi-fingerprint',
                          color: "#BF360C",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 27,
                          title: 'Laporan Ijin',
                          link: '/presensi/ijin',
                          icon: 'mdi-fingerprint',
                          color: "#BF360C",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                    id: 28,
                    title: 'Pembelian',
                    icon: 'mdi-cart-arrow-down',
                    color: "#827717",
                    link: '/pengajuan',
                    active: false,
                    sub_menu: [
                      {
                        id: 29,
                        title: 'Permintaan Stok',
                        link: '/pengajuan/pembelian-warehouse',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 64,
                      //   title: 'Permintaan Barang',
                      //   link: '/pengajuan/permintaan-barang',
                      //   icon: 'mdi-cart-arrow-down',
                      //   color: "#827717",
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 30,
                        title: 'Permintaan GM',
                        link: '/pengajuan/pembelian-general-manager',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 31,
                        title: 'Penerimaan Stok',
                        link: '/pengajuan/penerimaan/data',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 32,
                        title: 'QC Barang',
                        link: '/pengajuan/qc',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 44,
                    title: 'Order',
                    icon: 'mdi-order-bool-descending-variant',
                    color: "#455A64",
                    link: '/approval',
                    active: false,
                    sub_menu: [
                    {
                        id: 45,
                        title: 'Approval Order',
                        link: '/approval/order',
                        icon: 'mdi-order-bool-descending-variant',
                        color: "#455A64",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 46,
                        title: 'Approval Order Warehouse',
                        link: '/approval/order-warehouse',
                        icon: 'mdi-order-bool-descending-variant',
                        color: "#455A64",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 65,
                    title: 'Pengajuan Barang',
                    icon: 'mdi-text-box-plus',
                    color: "#4A148C",
                    link: '/pengajuan-barang',
                    active: false,
                    sub_menu: [
                    {
                        id: 66,
                        title: 'Data Pengajuan',
                        link: '/pengajuan-barang/data',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 67,
                        title: 'Approval Atasan',
                        link: '/pengajuan-barang/approval-atasan',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 68,
                        title: 'Approval General Manager',
                        link: '/pengajuan-barang/approval-general-manager',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 69,
                        title: 'Penerimaan Barang',
                        link: '/pengajuan-barang/approval-gudang',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 73,
                        title: 'Update harga & Pilih Supplier',
                        link: '/pengajuan-barang/update-harga-supplier',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 70,
                    title: 'Pembayaran Barang',
                    icon: 'mdi-basket-plus',
                    color:'#1B5E20',
                    active: false,
                    sub_menu: [
                      {
                        id: 71,
                        title: 'Kasir',
                        link: '/pembayaran-barang/kasir',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 72,
                        title: 'Akunting',
                        link: '/pembayaran-barang/akunting',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 74,
                        title: 'Approval Finance Manager',
                        link: '/pembayaran-barang/manager-keuangan',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 75,
                        title: 'Approval General Manager',
                        link: '/pembayaran-barang/general-manager',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 76,
                        title: 'Print Kasir',
                        link: '/pembayaran-barang/print-kasir',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      }
                    ]
                  },

                  {
                    id: 48,
                    title: 'Pengiriman ',
                    icon: 'mdi-gift',
                    color:'#006064',
                    link: '/delivery',
                    active: false,
                    sub_menu: [
                    {
                        id: 49,
                        title: 'Buat BPB',
                        link: '/delivery/bpb',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 50,
                        title: 'Buat Surat Jalan',
                        link: '/delivery/surat-jalan',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 77,
                        title: 'Proses Muat',
                        link: '/delivery/proses-muat',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 51,
                        title: 'Konfirmasi Pengiriman',
                        icon: 'mdi-gift',
                        color:'#006064',
                        link: '/konfirmasi-pengirirman',
                        active: false,
                        sub_menu: [],
                      },

                  {
                      id: 58,
                      title: 'Retur',
                      icon: 'mdi-gift',
                      color:'#006064',
                      link: '/retur',
                      active: false,
                      sub_menu: [], 
                    },
                    ],
                  },


                  {
                    id: 52,
                    title: 'Promo',
                    icon: 'mdi-percent-circle',
                    color:'#B71C1C',
                    link: '/promo',
                    active: false,
                    sub_menu: [
                    {
                        id: 53,
                        title: 'Data Promo',
                        link: '/promo/data',
                        icon: 'mdi-percent-circle',
                        color:'#B71C1C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 54,
                        title: 'Banner',
                        link: '/promo/banner',
                        icon: 'mdi-percent-circle',
                        color:'#B71C1C',
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 33,
                    title: 'Finance',
                    icon: 'mdi-book-open-page-variant',
                    color:'#4A148C',
                    link: '/finance',
                    active: false,
                    sub_menu: [
                    {
                        id: 34,
                        title: 'Data Penerimaan Stok',
                        link: '/finance/penerimaan/data',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 35,
                        title: 'Close PO',
                        link: '/finance/po/data',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 36,
                      //   title: 'Bank',
                      //   link: '/finance/bank',
                      //   icon: 'mdi-book-open-page-variant',
                      //   color:'#4A148C',
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 36,
                        title: 'Invoice Supplier',
                        link: '/finance/invoice-supplier',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 37,
                        title: 'Invoice Customer',
                        link: '/finance/invoice',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 62,
                      //   title: 'Approval Permintaan Barang',
                      //   link: '/finance/pengajuan',
                      //   icon: 'mdi-book-open-page-variant',
                      //   color:'#4A148C',
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },
                  {
                    id: 38,
                    title: 'Kasir',
                    icon: 'mdi-printer-pos',
                    icon_color: '#E65100',
                    link: '/kasir',
                    active: false,
                    sub_menu: [
                      {
                        id: 39,
                        title: 'Kasir Customer',
                        link: '/kasir/customer',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 40,
                        title: 'Kasir Supplier',
                        link: '/kasir/supplier',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 63,
                        title: 'Pembukuan Permintaan Barang',
                        link: '/kasir/pembukuan',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 55,
                    title: 'Pengaturan',
                    icon: 'mdi-cog',
                    color: 'black',
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        id: 5,
                        title: 'Cabang',
                        icon: 'mdi-cog',
                        color: 'black',
                        link: '/cabang',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 47,
                        title: 'Vehicle',
                        icon: 'mdi-cog',
                        color: 'black',
                        link: '/vehicle/data',
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 56,
                        title: 'Bank',
                        link: '/master/bank',
                        icon: 'mdi-cog',
                        color: 'black',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 57,
                        title: 'Config',
                        link: '/master/config',
                        icon: 'mdi-cog',
                        color: 'black',
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

        ],
              menu_profile = {
                      id: 15,
                      title: 'Profile',
                      icon: require('@/assets/icon/userGrey.png'),
                      icon_color: require('@/assets/icon/userBlack.png'),
                      link: '/setting',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Profile',
                          link: '/setting?menu=profile',
                          active: false,
                          sub_menu: [],
                        },
                        {
                          title: 'Password',
                          link: '/setting?menu=password',
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    }
              // if (menu_arr.length > 0) {
              //   menu_arr.push(menu_profile)
              // }

              // console.log(menu)
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu_default)
              )

              TokenService.saveReload(false)

              if (menu_arr.length > 0) {
                window.location = `${process.env.BASE_URL}setting?menu=profile`
                // if (menu_arr[0].sub_menu.length > 0) {
                //   window.location = `${process.env.BASE_URL}/${menu_arr[0].sub_menu[0].link}`
                // } else {
                //   window.location = `${process.env.BASE_URL}/${menu_arr[0].link}`
                // }
              } else {
                window.location = `${process.env.BASE_URL}user/staff`
              }

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>